<template>
    <div class="lb">
        <div class="lb-left">
            <div class="left-item" v-for="(item, i) in risetotal" :key="i">
                <img :src="i == 0 ? icon1 : icon2" alt="" class="item-icon">
                <div class="item-text">
                    <div class="left-text1">{{ item.name }}</div>
                    <div class="left-text2">
                        <div class="left-val" :ref="`defaultdata[${i}].value3`">{{ rateNum(`defaultdata[${i}].value3`, item.value) }}</div>
                        <em>%</em>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-line"></div>
        <div class="pie-chart">
            <div class="unit" v-if="defaultdata[0].value5">{{ defaultdata[0].value5 }}</div>
            <img src="@/assets/temimg9/right-bg1.png" alt="" class="bt1">
            <img src="@/assets/temimg9/right-icon2.png" alt="" class="bt2">
            <img src="@/assets/temimg9/rotate-icon.png" alt="" class="bt3-icon">
            <div class="pie-content" ref="piechart"></div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
import icon1 from '@/assets/temimg9/left-icon1.png'
import icon2 from '@/assets/temimg9/left-icon2.png'

export default {
    name: "template.scope87",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            icon1,
            icon2,
            title: "scope81-新数值条形图-完成",
            timer: null,
            defaultdata: [
                {
                    value1: "一月",
                    value2: "10",
                    value3: "50",
                    value4: '50',
                    value5: '62'
                }, {
                    value1: "二月",
                    value2: "11",
                    value3: "47",
                    value4: '55',
                    value5: '64'
                }, {
                    value1: "三月",
                    value2: "8",
                    value3: "45",
                    value4: '38',
                    value5: '51'
                }, {
                    value1: "四月",
                    value2: "9",
                    value3: "54",
                    value4: '44',
                    value5: '54'
                },
            ],
            nameList: ['累计收款完成率', '年度指标完成率'],
            valueMap: [
                { name: "月份", key: 'value1' },
                { name: "累计应收款", key: "value2" },
                { name: "累计实际收款", key: "value3" },
                { name: "年度目标", key: "value4" },
                { name: "单位", key: "value5" }
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            scopelist: [],
            isvideo: true,
            totalNum: 0,
            chartlist: [],
            risetotal: [
                { name: '累计收款完成率', value: 0 },
                { name: '年度指标完成率', value: 0 },
            ]
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.getChartdata()
        },
    },
    beforeDestroy() {
    },
    methods: {
        ...methods,
        getChartdata() {
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            let rateNum = 0
            let targetNum = 0
            vdata.forEach(item => {
                rateNum += (+item.value2 || 0)
                targetNum += (+item.value3 || 0)
            })
            this.risetotal[0].value = (+targetNum / +rateNum * 100).toFixed(2)
            this.risetotal[1].value = (+targetNum / +vdata[0].value4 * 100).toFixed(2)
            this.chartlist = vdata
            this.DrawEcharts()
        },
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require('echarts')
            var TmyChart = echarts.init(this.$refs.piechart)
            var colorList = ['#0481FF', '#04FFFF'];
            var length = ['累计应收款', '累计实际收款']
            const _this = this
            let chartdata = length.map((item, i) => {
                let value = this.chartlist[0][`value${i + 2}`]
                let newitem = {
                    name: item,
                    value: value
                }
                return newitem
            })
            var Toption = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    right: '10%',
                    orient: "vertical",
                    data: length,
                    formatter: (params) => {
                        return params + "\n" + this.numformat2(chartdata.filter(item => item.name == params)[0].value)
                    },
                    itemWidth: 10, // 设置图例图形的宽
                    itemHeight: 10, // 设置图例图形的高
                    itemGap: 15, //图例图标与文字间的间距
                    textStyle: {
                        color: "#d1e2ea", // 图例文字颜色
                        fontSize: 14,
                        lineHeight: 24,
                        rich: {
                            a: {
                                verticalAlign: "top",  //设置文字与图例的对其方式
                            },
                        },
                        padding: [2, 0, 2, 4], //[上、右、下、左] 图例与文字的偏移量
                    },
                },
                grid: {
                },
                series: [
                    // 主要展示层的
                    {
                        radius: ['68%', '82%'],
                        center: ['30%', '50%'],
                        type: 'pie',
                        avoidLabelOverlap: false,
                        padAngle: 4,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colorList[params.dataIndex]
                                }
                            },
                            borderRadius: 0,
                            borderColor: '#070e19', // 空隙的颜色，这里设置为白色
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                        },
                        emphasis: {
                            scale: false,
                        },
                        labelLine: {
                            show: false
                        },
                        data: chartdata
                    },
                ],
                animationDuration: 0,
                animationDurationUpdate: 3000,
                animationEasing: 'linear',
                animationEasingUpdate: 'linear'
            };
            TmyChart.clear()
            Toption && TmyChart.setOption(Toption);
            let seriesindex = 1
            this.timer = setInterval(() => {
                if (seriesindex < this.chartlist.length) {
                    chartdata.forEach((item, i) => {
                        item.value = +item.value + (+this.chartlist[seriesindex][`value${i + 2}`] || 0)
                    })
                    seriesindex += 1
                    Toption.series[0].data = chartdata
                    Toption && TmyChart.setOption(Toption);
                } else {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000);
            // this.timer = setInterval(function () {
            //     TmyChart.clear();
            //     Toption && TmyChart.setOption(Toption);
            // }, 5000)
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.getChartdata()
    },
};
</script>

<style scoped lang="scss">
.lb {
    width: 905px;
    height: 350px;
    padding: 10px 0;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    .lb-left {
        margin-left: 18px;

        .left-item {
            width: 357px;
            height: 117px;
            background: url(@/assets/temimg9/left-item-bg.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;

            &+.left-item {
                margin-top: 22px;
            }
        }

        .item-icon {
            margin-left: 34px;
            width: 75px;
            height: 87px;
        }
    }

    .item-text {
        margin: 10px 0 0 42px;

        .left-text1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 19px;
            color: #FFFFFF;
        }

        .left-text2 {
            font-family: Benmo Ziyu;
            font-weight: 400;
            font-size: 39px;
            color: #C6E6FF;
            margin-top: 10px;
            display: flex;
            align-items: flex-end;
            em {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 19px;
                color: #5C90BA;
                margin: 0 0 6px 8px;
            }
        }
    }

    .center-line {
        margin: 0 36px;
        width: 2px;
        height: 230px;
        background: linear-gradient(to bottom, #102442, #647E99, #102442);
    }

    .pie-chart {
        width: 420px;
        height: 230px;
        position: relative;
    }
    .pie-content {
        width: 100%;
        height: 100%;
    }

    .bt1 {
        width: 216px;
        height: 190px;
        position: absolute;
        top: 50%;
        left: 30%;
        transform: translate(-50%, -50%);
    }

    .bt2 {
        width: 52px;
        position: absolute;
        top: 50%;
        left: 31%;
        transform: translate(-50%, -50%);
    }

    .bt3-icon {
        width: 112px;
        position: absolute;
        top: calc(50% - 56px);
        left: calc(31% - 56px);
        animation: rotateXZ 3s linear infinite;
    }

    @keyframes rotateXZ {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .rotateXZ-element {
        animation: rotateXZ 4s linear infinite;
    }

    .pie-item {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        .pie-line {
            width: 74px;
            height: 4px;
        }

        .line-text1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            margin-top: 20px;
        }

        .line-text2 {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            margin-top: 32px;
        }

        .line-internal {
            height: 4px;
        }

        &.pie-item-0 {
            left: 0;

            .pie-line {
                background: #083572;
            }

            .line-internal {
                background: #0481FF;
            }

            .line-text1 {
                color: #0481FF;
            }
        }

        &.pie-item-1 {
            right: 0;

            .pie-line {
                background: #046C72;
            }

            .line-internal {
                background: #04FFFF;
            }

            .line-text1 {
                color: #06FFFF;
            }
        }
    }
    .unit {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #d1e2ea;
        position: absolute;
        left: 0px;
        top: -30px;
    }
}
</style>